<template><svg xmlns="http://www.w3.org/2000/svg" width="20" height="19.142" viewBox="0 0 89.18 78.03">

  <path d="M80.52,5.34c-4.24-3.62-9.4-5.34-14.6-5.34h0c-6.49,0-13.03,2.68-17.9,7.7l-3.43,3.54-3.43-3.54C36.3,2.68,29.76,0,23.27,0c-5.2,0-10.36,1.72-14.61,5.34C-2.28,14.67-2.85,31.43,6.93,41.55l33.7,34.8c1.09,1.12,2.52,1.69,3.94,1.69s2.86-.56,3.95-1.69l33.7-34.8c9.81-10.12,9.23-26.88-1.71-36.21Z"/>

</svg></template>